//#region types
import { FormEnums } from "models/enums";
import { FormFieldConstants, IconDefinitionConstants } from "utils/constants";
import { AutoCompleteExtraProps } from "models/propTypes/genericFormProps";
import { GenericFormSection } from "models/propTypes/genericFormProps";
import { BusinessUnitFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
import { FilterQueryStateHandler } from "models/propTypes/filterPropTypes";
//#region components
import { useBusinessUnitService } from "serviceHooks";
//#endregion
import { QueryStateHelper } from "utils/helpers";

function useBusinessUnitReportFilterDefinition() {
  const businessUnitService = useBusinessUnitService();
  const filterFormFields: GenericFormSection<BusinessUnitFormTypes.Filter>[] = [
    {
      label: TranslationKeys.Common.General,
      type: FormEnums.FormSectionType.EXPANDABLESECTION,
      icon: IconDefinitionConstants.WSliders,
      innerFields: {
        managerName: {
          label: TranslationKeys.BusinessUnit.Manager,
          type: FormEnums.FormFieldType.AUTOCOMPLETE,
          extraProps: {
            items: (searchStr: string) => businessUnitService.searchBusinessMangersAutoComplete(searchStr, false),
            referenceFieldName: FormFieldConstants.BusinessUnit.Filter.BusinessUnitManagerId,
          } as AutoCompleteExtraProps<BusinessUnitFormTypes.Filter>,
          hidden: false,
        },
        period: {
          label: TranslationKeys.Common.Date,
          type: FormEnums.FormFieldType.MONTH,
        },
      },
    },
  ];

  const filterQueryStateHandler: FilterQueryStateHandler<BusinessUnitFormTypes.Filter> = {
    businessUnitId: QueryStateHelper.stringQueryEncoder(FormFieldConstants.BusinessUnit.Filter.BusinessUnitId),
    businessUnitName: QueryStateHelper.stringQueryEncoder(FormFieldConstants.BusinessUnit.Filter.BusinessUnitName),
    businessUnitManagerId: QueryStateHelper.numberQueryEncoder(
      FormFieldConstants.BusinessUnit.Filter.BusinessUnitManagerId
    ),
    managerName: QueryStateHelper.stringQueryEncoder(FormFieldConstants.BusinessUnit.Filter.ManagerName),
    period: QueryStateHelper.monthQueryEncoder(FormFieldConstants.BusinessUnit.Filter.Period),
  };

  return { filterFormFields, filterQueryStateHandler };
}

export default useBusinessUnitReportFilterDefinition;
